module.exports = __webpack_public_path__ + "img/ring_g_0_1_1@2x.11a1e8ae.png";